import { useAuth } from '@payflip/web/auth';
import {
  ImpersonateDangerModal,
  useStopEmployeeImpersonation
} from '../components/impersonate';
import { OnboardingModal } from '../components/onboarding-modal';
import { useEmployeeStatusQuery } from './queries.generated';

export function GlobalModals(): JSX.Element | null {
  const { isAuthenticated } = useAuth();
  const { data } = useEmployeeStatusQuery({
    skip: !isAuthenticated
  });
  const { loading, stopEmployeeImpersonation } = useStopEmployeeImpersonation({
    companyId: data?.company.id as string,
    employeeId: data?.employee.id as string
  });

  if (!data) {
    return null;
  }

  const {
    employee: {
      onboarded,
      user: { isImpersonated }
    }
  } = data;

  return (
    <>
      {!onboarded && !isImpersonated ? <OnboardingModal /> : null}
      {!onboarded && isImpersonated ? (
        <ImpersonateDangerModal
          loading={loading}
          onStop={() => {
            stopEmployeeImpersonation();
          }}
        />
      ) : null}
    </>
  );
}
